import React from 'react'
import { TextField, FormControl, InputLabel, Select, MenuItem, Autocomplete } from '@mui/material'

type Props = {
	component?: 'input' | 'textarea' | 'select' | 'autocomplete'
	input: any
	id?: string
	name?: string
	placeholder?: string
	defaultValue?: string
	options?: any
	disabled?: boolean
	readOnly?: boolean
	required?: boolean
	rows?: number
	pipe?: (value: string) => string
}

const FinalFormInput: React.FC<Props> = ({
	component = 'input',
	input,
	id,
	name,
	placeholder,
	defaultValue,
	options,
	disabled = false,
	readOnly = false,
	required = false,
	rows = 3,
	pipe,
	...props
}) => {
	const handleChange = (e: any) => {
		input.onChange(pipe ? pipe(e.target.value) : e.target.value)
	}
	return (
		<>
			{component === 'input' && (
				<TextField
					type='text'
					id={id}
					name={name}
					label={placeholder}
					defaultValue={defaultValue}
					disabled={disabled}
					onChange={handleChange}
					required={required}
					InputProps={{
						style: { fontFamily: 'Open Sans' },
						readOnly: readOnly,
					}}
					{...input}
				/>
			)}
			{component === 'textarea' && (
				<TextField
					id={id}
					name={name}
					label={placeholder}
					multiline
					rows={rows}
					defaultValue={defaultValue}
					disabled={disabled}
					onChange={handleChange}
					required={required}
					InputProps={{
						style: { fontFamily: 'Open Sans' },
						readOnly: readOnly,
					}}
					{...input}
				/>
			)}
			{component === 'select' && (
				<FormControl fullWidth>
					<InputLabel id='demo-simple-select-label'>{placeholder}</InputLabel>
					<Select
						labelId='demo-simple-select-label'
						id={id}
						name={name}
						label={placeholder}
						defaultValue={defaultValue}
						disabled={disabled}
						onChange={handleChange}
						required={required}
						inputProps={{ readOnly: readOnly }}
						{...input}
					>
						{options.map((option: any, index: any) => (
							<MenuItem value={option} key={index}>
								{option}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			)}
			{component === 'autocomplete' && (
				<Autocomplete
					freeSolo
					id='free-solo-2-demo'
					disableClearable
					options={options}
					onSelect={handleChange}
					readOnly={readOnly}
					defaultValue={defaultValue}
					renderInput={(params) => (
						<TextField
							{...params}
							label={placeholder}
							id={id}
							name={name}
							defaultValue={defaultValue}
							disabled={disabled}
							onChange={handleChange}
							required={required}
							InputProps={{
								...params.InputProps,
								type: 'search',
								style: { fontFamily: 'Open Sans' },
								readOnly: readOnly,
							}}
						/>
					)}
				/>
			)}
		</>
	)
}

export default FinalFormInput
